import { KClassImpl3o7kfo8v13fhm as KClassImpl } from './kotlin/reflect/js/internal/KClassImpl.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function findAssociatedObject(_this__u8e3s4, annotationClass) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof KClassImpl()) {
    tmp_0 = annotationClass instanceof KClassImpl();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = annotationClass.ye();
    var tmp0_elvis_lhs = getAssociatedObjectId(tmp$ret$0);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var key = tmp_1;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp1_safe_receiver = _this__u8e3s4.ye().$metadata$;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.associatedObjects;
    var tmp_2;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_2 = tmp2_elvis_lhs;
    }
    var map = tmp_2;
    var tmp3_elvis_lhs = map[key];
    var tmp_3;
    if (tmp3_elvis_lhs == null) {
      return null;
    } else {
      tmp_3 = tmp3_elvis_lhs;
    }
    var factory = tmp_3;
    return factory();
  } else {
    tmp = null;
  }
  return tmp;
}
function getAssociatedObjectId(annotationClass) {
  var tmp0_safe_receiver = annotationClass.$metadata$;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.associatedObjectKey;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = tmp1_safe_receiver;
  }
  return tmp;
}
//region block: exports
export {
  findAssociatedObject as findAssociatedObject1kb88g16k1goa,
};
//endregion

//# sourceMappingURL=reflectionJs.mjs.map
